import { Dropdown } from 'antd';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import TableMenu from './TableMenu';
import { IGuide } from '../../../interfaces/express-delivery.interface';

interface Props {
    item: IGuide;
    setItemSelected: (item: IGuide) => void;
}

const Actions = ({ item, setItemSelected }: Props) => (
    <Dropdown
        placement="bottomRight"
        trigger={['click']}
        overlay={(
            <TableMenu
                item={item}
                setItemSelected={setItemSelected}
            />
        )}
        // @ts-ignore
        onClick={(e: any) => { e.stopPropagation(); }}
    >
        <BiDotsVerticalRounded size={24} />
    </Dropdown>
);

export default Actions;
